var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9989 29.7566V35.3377C39.001 35.8558 38.8948 36.3686 38.6873 36.8433C38.4797 37.318 38.1753 37.7442 37.7935 38.0944C37.4117 38.4447 36.961 38.7114 36.4702 38.8774C35.9794 39.0433 35.4593 39.105 34.9433 39.0584C29.2187 38.4363 23.7198 36.4802 18.8885 33.3471C14.3935 30.4908 10.5826 26.6799 7.72637 22.185C4.58234 17.3317 2.62575 11.8061 2.0151 6.05574C1.96861 5.54129 2.02975 5.0228 2.19462 4.53328C2.3595 4.04375 2.6245 3.59392 2.97274 3.21242C3.32099 2.83093 3.74486 2.52612 4.21737 2.31741C4.68987 2.1087 5.20065 2.00067 5.7172 2.00018H11.2982C12.2011 1.99129 13.0764 2.311 13.7609 2.89972C14.4455 3.48844 14.8926 4.30598 15.0189 5.19998C15.2545 6.98604 15.6914 8.73972 16.3212 10.4276C16.5715 11.0934 16.6257 11.8171 16.4773 12.5128C16.3289 13.2085 15.9842 13.8471 15.484 14.3529L13.1214 16.7155C15.7697 21.373 19.626 25.2293 24.2835 27.8776L26.6461 25.515C27.1519 25.0148 27.7905 24.6701 28.4862 24.5218C29.1819 24.3734 29.9056 24.4275 30.5715 24.6778C32.2593 25.3077 34.013 25.7445 35.7991 25.9801C36.7027 26.1076 37.5281 26.5628 38.118 27.2591C38.708 27.9554 39.0215 28.8442 38.9989 29.7566Z",
    stroke: "#C49A36",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.28cd5923.svg";
export { ForwardRef as ReactComponent };